import { render, staticRenderFns } from "./SupplierSearch.vue?vue&type=template&id=197fbc00&scoped=true&"
import script from "./SupplierSearch.vue?vue&type=script&lang=js&"
export * from "./SupplierSearch.vue?vue&type=script&lang=js&"
import style0 from "./SupplierSearch.vue?vue&type=style&index=0&id=197fbc00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197fbc00",
  null
  
)

export default component.exports